export default __webpack_public_path__ + "static/media/thumbnail_image_6.a151b680.png";